module.exports = __webpack_public_path__ + "static/3-b4a81d0458b87b8999432934b3c86811.png";